import TokenIcon from "@mui/icons-material/Token";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import PersonIcon from "@mui/icons-material/Person";
import Dashboard from "../Pages/Dashboard";
import Categories from "../Pages/Categories";
import AllUsers from "../Pages/AllUsers";
import UserProfile from "../Pages/FoodCategory";
import AddCategory from "../Pages/AddCategory";
import Resturants from "../Pages/Resturants";
import Users from "../Pages/AllUsers";
import FoodCategory from "../Pages/FoodCategory";
import EditResturant from "../Pages/EditResturant";
import AddAmenite from "../Pages/AddAmenite";
import AdminProfile from "../Pages/AdminAccount";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import GroupIcon from "@mui/icons-material/Group";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EditUser from "../Pages/EditUser";
import AddMenu from "../Pages/AddMenu";
import EditMenu from "../Pages/EditMenu";
import DailySpecials from "../Pages/DailySpecials";
import Featured from "../Pages/Featured";
import HappyHours from "../Pages/HappyHours";
import KidsMenu from "../Pages/KidsMenus";
import Events from "../Pages/Events";
import NewPlaces from "../Pages/NewPlaces";
import Dining from "../Pages/Dining";
import subscriptionicon from "../Assets/mdi_playlist-star.svg";
import arcticons_dailypic from "../Assets/arcticons_dailypic.svg";
import ic_outline_event_note from "../Assets/ic_outline-event-note.svg";
import ic_location from "../Assets/ic_outline-add-location-alt.svg";
import cil_dinner from "../Assets/cil_dinner.svg";
// arcticons_dailypic
export const routes = [
  {
    title: "Dashboards",
    name: "resturants",
    icon: <DashboardIcon />,
    component: <Resturants />,
  },

  {
    title: "Categories",
    name: "Categories",
    icon: <TokenIcon />,
    component: <Categories />,
  },

  {
    title: "Users",
    name: "Users",
    icon: <GroupIcon />,
    component: <Users />,
  },
  {
    title: "Food Category",
    name: "Food_Category",
    icon: <RestaurantIcon />,
    component: <FoodCategory />,
  },
  {
    title: "Amenities",
    name: "Amenities",
    icon: <PhotoLibraryIcon />,
    component: <AddAmenite />,
  },
  {
    title: "Admin Profile",
    name: "AdminProfile",
    icon: <PersonIcon />,
    component: <AdminProfile />,
  },
  {
    title: "Featured",
    name: "Featured",
    // icon: <PersonIcon />,
    component: <Featured />,
    src: subscriptionicon,
  },
  {
    title: "Daily Specials",
    name: "Daily_Specials",
    // icon: <PersonIcon/>,
    component: <DailySpecials />,
    src: arcticons_dailypic,
  },
  {
    title: "Events",
    name: "Events",
    src: ic_outline_event_note,
    // icon: <PersonIcon />,
    component: <Events />,
  },
  ,
  {
    title: "New Places",
    name: "New_Places",
    // icon: <PersonIcon />,
    component: <NewPlaces />,
    src: ic_location,
  },

  {
    title: "Dining",
    name: "Dining",
    // icon: <PersonIcon />,
    component: <Dining />,
    src: cil_dinner,
  },
];

export const Editroutes = [
  {
    name: ":category/:categoryId",
    icon: <PersonIcon />,
    component: <EditResturant />,
  },
  { name: "edit_user/:userId", icon: <PersonIcon />, component: <EditUser /> },
  {
    name: ":category/:categoryId/edit_menu/:menuId",
    icon: <PersonIcon />,
    component: <EditMenu />,
  },
  {
    name: "happy_hours/:restaurantID",
    icon: <PersonIcon />,
    component: <HappyHours />,
  },
];

export const Addroutes = [
  {
    name: ":category/:categoryId/add_menu",
    icon: <PersonIcon />,
    component: <AddMenu />,
  },
  {
    name: "kids_menu/:restaurantID",
    icon: <PersonIcon />,
    component: <KidsMenu />,
  },
];
